export default __webpack_public_path__ + "static/media/execute_typeofQuestions.e9155a2f.png";